import { LazyPage, PipelineDestinationLayoutPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function PipelineDestinationLayoutRoute() {
  return (
    <LazyPage>
      <PipelineDestinationLayoutPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId')({
  component: PipelineDestinationLayoutRoute,
});
